/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_PaletteiconInputs */

const en_enum_custom_page_icon_paletteicon = /** @type {(inputs: Enum_Custom_Page_Icon_PaletteiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palette`)
};

const de_enum_custom_page_icon_paletteicon = /** @type {(inputs: Enum_Custom_Page_Icon_PaletteiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palette`)
};

/**
* | output |
* | --- |
* | "Palette" |
*
* @param {Enum_Custom_Page_Icon_PaletteiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_paletteicon = /** @type {((inputs?: Enum_Custom_Page_Icon_PaletteiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_PaletteiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_paletteicon(inputs)
	return de_enum_custom_page_icon_paletteicon(inputs)
});